<!-- 
Listing of providers.
-->
<template>
  <div>
    <v-card class="home">
      <our-table-header 
        :listing="listing"
        :search-filters="searchFilters"
        :criteria-mutation="criteriaMutation"
        :has-export="hasExport"
        @update:criteria="refresh"
        @update:pageNumber="updatePageNumber" 
        @click:refresh="refresh" 
        @click:export="exportToExcel" 
      />
      <our-table-busy-indicator :show="listing.loading"/>
      <v-data-table 
        :headers="headers" 
        :items="listing.data" 
        :pagination="listing.paging" 
        :total-items="listing.paging.totalItems" 
        :rows-per-page-items="rowsPerPageItems" 
        :no-data-text="noDataText"
        must-sort 
        hide-actions
        @update:pagination="updatePagination"
      >
        <template slot="items" slot-scope="props">
          <tr @click.stop="rowSelected(props.item.id, props.item)">
            <our-nav-col :row="props.item.name"/>
            <td>{{ props.item.name }}</td>
            <td>{{ props.item.providerCode }}</td>
            <td>{{ props.item.tradingNames }}</td>
            <td class="text-xs-center px-2">
              <v-tooltip v-if="props.item.hasNotes" bottom>
                <v-btn 
                  slot="activator" 
                  :to="`/providers/${props.item.id}/notes`" 
                  color="grey darken-2"
                  flat class="notes-icon"
                  @click.stop
                >
                  <v-icon>
                    event_note
                  </v-icon>
                </v-btn>
                <span>Provider has notes</span>
              </v-tooltip>
            </td>
          </tr>
        </template>
      </v-data-table>
      <our-table-footer :paging="listing.paging" @update:pageNumber="updatePageNumber" @update:rowsPerPage="updateRowsPerPage" />
    </v-card>
  </div>
</template>

<script>
import tableMixins from "@/mixins/table.mixins";
import * as action from "@/store/providers/action-types";
import * as mutation from "@/store/providers/mutation-types";
import { PROVIDERS_EXPORT } from "@/store/claim-types";
import { getSearchFilters } from "@/store/providers/helpers";

export default {
  mixins: [tableMixins],
  data() {
    return {
      providerId: null,
      action: action.LIST,
      exportAction: action.EXPORT,
      criteriaMutation: mutation.LIST_SET_CRITERIA,
      pagingMutation: mutation.LIST_SET_PAGING,
      defaultNoDataText: "No providers have been imported yet."
    };
  },
  computed: {
    headers() {
      return [
        { text: "", value: "Id", class: "navCol", width: 0, sortable: false },
        { text: "Legal name", value: "Name", sortable: this.canSort },
        { text: "Provider code", value: "ProviderCode", sortable: this.canSort, width: 100 },
        { text: "Trading names", value: "TradingNames", sortable: this.canSort },
        { text: "", value: "Id", sortable: false, align: "right", width: 100 }
      ];
    },
    listing() {
      return this.$store.state.providers.listing;
    },
    searchFilters() {
      return getSearchFilters();
    },
    criteria() {
      return this.listing.criteria;
    },
    loaded() {
      return this.listing.loaded;
    },
    hasExport() {
      return this.$store.getters.claims.includes(PROVIDERS_EXPORT);
    }
  },
  watch: {
    loaded() {
      this.reload();
    }
  },
  mounted() {
    this.reload();
  },
  methods: {
    reload() {
      if (!this.listing.loaded && !this.listing.loading) {
        this.populate();
      }
    }
  }
};
</script>

<style scoped lang="scss">
.notes-icon {
  margin: 0;
  padding: 0px;
  min-width: 35px;
  height: 30px;
  i {
    font-size: 22px;
  }
}
</style>